import { render, staticRenderFns } from "./FormsTable.vue?vue&type=template&id=03696f64&"
import script from "./FormsTable.vue?vue&type=script&lang=js&"
export * from "./FormsTable.vue?vue&type=script&lang=js&"
import style0 from "./FormsTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports